import Vue from 'vue'
import Router from 'vue-router'
import {getStorage} from '@/utils/index.js'

const Index = resolve => require(['@/pages/Index'], resolve) // 首页
const Sign = resolve => require(['@/pages/Sign'], resolve) // 登录注册
const Messenger = resolve => require(['@/pages/Messenger'], resolve) // 留言板
// const Register = resolve => require(['@/pages/Register'],resolve);                  // 注册
const FindPassword = resolve => require(['@/pages/FindPassword'], resolve) // 找回密码
const Cloud = resolve => require(['@/pages/Cloud'], resolve) // 详情service
const Server = resolve => require(['@/pages/Server'], resolve) // 详情cloud
const Technical = resolve => require(['@/pages/Technical'], resolve) // 技术服务
const Docs = resolve => require(['@/pages/Docs'], resolve) // 文档
const Customer = resolve => require(['@/pages/Customer'], resolve) // 客户案列
const CustomerCase = resolve => require(['@/pages/CustomerCase'], resolve) // 客户案列概览
const CustomerDetail = resolve => require(['@/pages/CustomerDetail'], resolve) // 客户案列详情
const Trade = resolve => require(['@/pages/Trade'], resolve) // 行业贡献
const Download = resolve => require(['@/pages/Download'], resolve) //试用
const AboutUs = resolve => require(['@/pages/AboutUs'], resolve) // 关于我们
const JoinUs = resolve => require(['@/pages/JoinUs'], resolve) //加入我们
const News = resolve => require(['@/pages/News'], resolve) // 新闻列表
const NewsDetail = resolve => require(['@/pages/NewsDetail'], resolve) // 新闻详情
const Confirm = resolve => require(['@/pages/Confirm'], resolve) // 用户操作
const UserInfo = resolve => require(['@/pages/UserInfo'], resolve) // 用户信息
const ChangePassword = resolve => require(['@/pages/ChangePassword'], resolve) // 用户信息
const AuthManage = resolve => require(['@/pages/authmanage'], resolve) // 授权管理
const AuthManageList = resolve => require(['@/pages/authmanage/checkListDownload'], resolve) // 授权管理下载列表
const NotFound = resolve => require(['@/pages/NotFound'], resolve) // 404

Vue.use(Router)

//TODO web端和mobile端的路由统一

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/',
      redirect: '/index'
    }, {
      path: '/index',
      name: 'Index',
      component: Index
    }, {
      path: '/sign',
      name: 'sign',
      component: Sign
    }, {
      path: '/find-password',
      name: 'find-password',
      component: FindPassword
    },{
      path: '/messenger',
      name: 'messenger',
      component: Messenger
    }, {
      path: '/server',
      name: 'server',
      component: Server
    }, {
      path: '/cloud',
      name: 'cloud',
      component: Cloud
    }, {
      path: '/docs',
      name: 'Docs',
      component: Docs
    }, {
      path: '/customer',
      name: 'customer',
      component: Customer
    }, {
      path: '/customer-case',
      name: 'customer-case',
      component: CustomerCase
    }, {
      path: '/customer/:detailId',
      name: 'customer-detail',
      component: CustomerDetail
    }, {
      path: '/trade',
      name: 'trade',
      component: Trade
    }, {
      path: '/download',
      name: 'download',
      component: Download
    }, {
      path: '/aboutUs',
      name: 'about-us',
      component: AboutUs
    },{
      path: '/join-us',
      name: 'join-us',
      component: JoinUs
    }, {
      path: '/news',
      name: 'news',
      component: News
    }, {
      path: '/news/:newId',
      name: 'news-detail',
      component: NewsDetail
    }, {
      path: '/confirm',
      name: 'confirm',
      component: Confirm
    }, {
      path: '/user-info',
      name: 'user-info',
      component: UserInfo
    }, {
      path: '/change-password',
      name: 'change-password',
      component: ChangePassword
    },  {
      path: '/authmanage',
      name: 'authmanage',
      component: AuthManage,
    }, {
      path: '/authmanage/list',
      name: 'AuthManageList',
      component: AuthManageList
    }
    //, {
    //  //未知的路由重定向到首页而非404
    //  path: '/*',
    //  redirect: '/'
    //}
  ]
})

router.beforeEach((to, from, next) => {
  //加入我们&新闻详情 英文环境 不给入口
  if(localStorage.getItem('language') == 'en') {
    if(to.name == 'join-us' || to.name == 'news') {
      next({path: '/index'})
    }
  }
  if(to.name == 'authmanage' && !getStorage("isLogin")) {
    next({name: 'sign'})
  }
  if(to.name == 'AuthManageList' && !getStorage("isLogin")) {
    next({name: 'sign'})
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js